// Website Creator: htutkhaung.ko@msgtech.co.th
import { initI18n } from './i18n.js';
import { initSolutions } from './solutions.js';
import { initContact } from './contact.js';
import { initTelemetryCanvas, initParallaxEngine } from './telemetry-canvas.js';
import { initMalaScaleSim } from './mala-scale-sim.js';

document.addEventListener('DOMContentLoaded', () => {
  // Initialize multilingual engine (Thai default)
  initI18n();

  // Initialize dynamic modules
  initSolutions();
  initContact();
  initTelemetryCanvas();
  initParallaxEngine();
  initMalaScaleSim();

  // Sticky Navbar Blur & Shadow on scroll
  const navbar = document.querySelector('.navbar');
  window.addEventListener('scroll', () => {
    if (window.scrollY > 30) {
      navbar?.classList.add('scrolled');
    } else {
      navbar?.classList.remove('scrolled');
    }
  });

  // Mobile menu toggle
  const mobileToggle = document.querySelector('.mobile-toggle');
  const mobileDrawer = document.getElementById('mobile-drawer');
  const drawerLinks = document.querySelectorAll('.drawer-link');

  mobileToggle?.addEventListener('click', () => {
    mobileDrawer?.classList.toggle('active');
  });

  drawerLinks.forEach(link => {
    link.addEventListener('click', () => {
      mobileDrawer?.classList.remove('active');
    });
  });
});
